<template>
    <div class="DshBox">
        <div class="DshBox-list">
            <component
                :is="`Dsh${$firstUpperCase(mode)}`"
                ref="list"
                :data="data"
                :columns="columns"
                :ownColumns="ownColumns"
                :operationList="operationList"
                :extraOperationList="extraOperationList"
                :propsObj="listPropsObj"
                :noDataText="listPropsObj&&listPropsObj.noDataText || '暂无数据...'"
                @clickRow="clickRow"
                @sortChange="changeSort"
                @selectChange="changeSelect"
                @selectAll="selectAll"
                @select="select"
                @groupScroll="groupScroll"
                @groupLoad="groupLoad"
                @dsh="dshEmit"
            ></component>
        </div>

        <!-- 分页 -->
        <div
            v-if="!['panel', 'singleData'].includes(mode) && pagePropsObj"
            class="DshBox-page"
        >
            <dsh-page
                :mode="pageMode"
                :total="total"
                :propsObj="pagePropsObj"
                @changePage="changePage"
                @changePageSize="changePageSize"
            ></dsh-page>
        </div>
    </div>
</template>

<script>
    // 表格模式、竖向表格模式、卡片模式、看板模式
    const tableTypes = ["table", "crossTable", "panel", "card", "list", "singleData"];
    // 得到组件注册对象
    function registerComponents (types) {
        return types.reduce((obj, item) => {
            const componentName = `Dsh${item.toString()[0].toUpperCase()}${item.toString().slice(1)}`;
            return Object.assign(obj, {
                [componentName]: () => import(`./${componentName}.vue`)
            });
        }, {});
    };

    export default {
        name: "DshBox",
        components: registerComponents(tableTypes),
        props: {
            mode: {
                type: String,
                default: "list",
                validator: function (val) {
                    return ["table", "crossTable", "panel", "card", "list", "singleData"].includes(val);
                }
            },

            data: Array,
            columns: Array,
            operationList: Array,
            extraOperationList: Array,
            listPropsObj: Object,
            pageMode: String,
            total: Number,
            pagePropsObj: Object,
            ownColumns: Array
        },
        data () {
            return {};
        },
        computed: {},
        created () {
        },
        methods: {
            // 点击某行
            clickRow (...params) {
                this.$emit("clickRow", ...params);
            },

            // 改变选择项
            changeSort (...params) {
                this.$emit("sortChange", ...params);
            },
            // 改变选择项
            changeSelect (...params) {
                this.$emit("selectChange", ...params);
            },
            // 切换全选
            selectAll (...params) {
                this.$emit("selectAll", ...params);
            },
            // 切换选择
            select (...params) {
                this.$emit("select", ...params);
            },
            // 看板分组列表滚动事件
            groupScroll (...params) {
                this.$emit("groupScroll", ...params);
            },
            // 看板分组列表滚动至底部事件
            groupLoad (...params) {
                this.$emit("groupLoad", ...params);
            },

            // 转发
            dshEmit (...params) {
                this.$emit("dsh", ...params);
            },
            // 切换分页
            changePage (...params) {
                this.$emit("changePage", ...params);
            },
            // 切换分页条数
            changePageSize (...params) {
                this.$emit("changePageSize", ...params);
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshBox {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        &-list {
            width: 100%;
            flex: 1;
            min-height: 60px;
            overflow: auto;
            background: #fff;
            border-radius: 6px;
        }
        &-page {
            width: 100%;
            height: 40px;
            padding: 5px 20px;
        }
    }
</style>
<style lang="less">
    .DshBox {
        // &-tooltip {
        //     width: 100%;
        //     height: 100%;
        //     .ivu-tooltip-rel {
        //         width: 100%;
        //         height: 100%;
        //         &-tooltip-box {
        //             display: inline-block;
        //             width: 100%;
        //             height: 32px;
        //             overflow: hidden;
        //             text-overflow: ellipsis;
        //             white-space: nowrap;
        //         }
        //     }
        // }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/list/DshBox/DshBox.vue